import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { ReadMoreIcon } from 'components/appIcons';
import AppModal from 'components/AppModal';
import { RecordValue } from 'components/AppTable';
import UssdSessionDetails from './UssdSessionDetails';
import { IUssdSessionInfo } from './UssdSession.model';

interface IUssdSessionsActionMenuProps {
  id: RecordValue;
  ussdSession: IUssdSessionInfo;
}

const UssdSessionsActionMenu = ({ ussdSession }: IUssdSessionsActionMenuProps) => {
  const { t } = useTranslation();
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);

  const handleOpenDetails = useCallback(() => {
    setIsDetailsOpen(true);
  }, []);
  const handleCloseDetails = useCallback(() => {
    setIsDetailsOpen(false);
  }, []);

  const modalTitle = useMemo(
    () => `${t('labels:viewMoreDetailsAbout')} ${ussdSession.sessionId}`,
    [ussdSession.sessionId]
  );

  return (
    <>
      <Button onClick={handleOpenDetails} startIcon={<ReadMoreIcon />} sx={{ color: 'info.main' }}>
        {t('labels:details')}
      </Button>

      <AppModal title={modalTitle} open={isDetailsOpen} onClose={handleCloseDetails} size="md">
        <UssdSessionDetails ussdSession={ussdSession}></UssdSessionDetails>
      </AppModal>
    </>
  );
};

export default UssdSessionsActionMenu;
